<template>
  <div class="wx-biz-class-teacher-message-push"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="bizList">
      <div class="biz-wrap">
        <div class="header">
          <el-select v-model="biz"
                     size="mini"
                     filterable
                     value-key="code"
                     placeholder="请选择业务类型">
            <el-option v-for="biz in bizList"
                       :key="biz.code"
                       :label="biz.name"
                       :value="biz"></el-option>
          </el-select>
        </div>
        <div class="main">
          <div class="main-cont">
            <template v-if="biz">
              <WxBizClassTeacherMessagePushInput :biz="biz"
                                                 v-on="$listeners"></WxBizClassTeacherMessagePushInput>
            </template>
            <template v-else>
              <Hint>
                <div>请选择业务类型</div>
              </Hint>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>业务数据加载失败</div>
        <el-button type="text"
                   @click="loadBizList">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import WxBizClassTeacherMessagePushInput from './input'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxBizClassTeacherMessagePush',
  components: {
    WxBizClassTeacherMessagePushInput,
    Hint
  },
  data () {
    return {
      loading: false,
      bizList: null,
      biz: null
    }
  },
  methods: {
    loadBizList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/classTeacher/bizList',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.bizList = response.data['bizList'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadBizList()
  }
}
</script>

<style lang="scss">
  .wx-biz-class-teacher-message-push {
    height: 100%;
    & > .biz-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        padding: 15px;
        .el-select {
          width: 100%;
        }
      }
      & > .main {
        flex: auto;
        position: relative;
        & > .main-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
</style>
